import CustomTab from '../../../../../components/CustomTab';
import CustomTabContainer from '../../../../../components/CustomTabContainer';
import DashboardApp from '../Functionality/DashboardApp';
import FinesMap from './FinesMap';
import TrafficFinesMainHeader from './TrafficFinesMainHeader';
import {TAB_OPTIONS} from '../Model/Model';
import {TRAFFIC_SUB_VIEW_MODEL} from "../../Model/Model";
import GeofencesTab from "./GeofencesTab";

/**
 * @Email : kpozs@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: FullStack
 */
const Dashboard = ({ subView, handleSubViewChange, searchElement, setSearchElement,
                       selectedInnerView, handleStepSelectedInnerView, showFinesModal, setShowFinesModal,
                       setCriteria, setBodyForExport, setSearch
}) => {

    const {
        t,
        totalElements,
        setTotalElements,
        DEV,
        permission,
        searchLocation,
        handleChange,
        selectEmployee,
        setSelectEmployee,
        direction,
        setDirection,
        handleMapMove,
        dispatch,
        bodyAutocompleteSearch,
        TrafficFinesTabsPermission,
        option,
        reset,
        setReset
    } = DashboardApp();

    return (
        <>
            <TrafficFinesMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                permission={permission}
                DEV={DEV}
                selectedInnerView={selectedInnerView}
                selectEmployee={selectEmployee}
                setSelectEmployee={setSelectEmployee}
                bodyAutocompleteSearch={bodyAutocompleteSearch}
                option={option}
                reset={reset}
                setReset={setReset}
            />


            <div className={`border-full-shades-100 border-radius-8px mt-3 `}>
                <div className="d-flex">
                    <div >
                            { TrafficFinesTabsPermission?.length > 0 &&
                            <CustomTabContainer activeTab={selectedInnerView} setActiveTab={handleStepSelectedInnerView} className="rounded-top border-0 px-2">
                                {TrafficFinesTabsPermission.map((item) => (
                                    <CustomTab
                                        key={item.key}
                                        id={item.key}
                                        title={t(item.translation)}
                                        icon={item.icon}
                                        selected={selectedInnerView === item.key}
                                        onClick={() => handleStepSelectedInnerView(item.key)}
                                    />
                                ))}
                            </CustomTabContainer>
                        }
                    </div>
                    <div className="vertical-separator-shades-950 h-36px align-self-center" />
                    <div className="d-flex align-items-center gap-1 custom-tab-container pl-1">
                        <span className='ibl-font-w-500 fs-16px font-color-general-950'>
                            {t(
                                subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD &&
                                selectedInnerView === TAB_OPTIONS.GEOFENCES
                                    ? 'your_fields'
                                    : 'total_fines'
                            )}
                        </span>

                        {totalElements != null && (
                            <div className="custom-tab-news-number d-flex px-2 justify-content-center align-items-center border-radius-8px cursor-pointer minw-18px h-fit">
                                {totalElements}
                            </div>
                        )}
                    </div>
                </div>

                {selectedInnerView === TAB_OPTIONS.GEOFENCES &&
                    <GeofencesTab
                        direction={direction}
                        handleMapMove={handleMapMove}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setTotalElements={setTotalElements}
                    />
                }
                {selectedInnerView === TAB_OPTIONS.FINES && (
                    <FinesMap
                        dispatch={dispatch}
                        searchLocation={searchLocation}
                        handleChange={handleChange}
                        t={t}
                        direction={direction}
                        setDirection={setDirection}
                        selectEmployee={selectEmployee}
                        setSelectEmployee={setSelectEmployee}
                        setTotalElements={setTotalElements}
                        reset={reset}
                        setReset={setReset}
                        showFinesModal={showFinesModal}
                        setShowFinesModal={setShowFinesModal}
                        handleMapMove={handleMapMove}
                        setCriteria={setCriteria}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                    />
                )}
            </div>
        </>
    );
};

export default Dashboard;
